import React, { useEffect, useState } from 'react';
import Text from '@/components/ui/Text';
import { Input } from '@/components/ui/Form';
import { SubmitButton } from '@/components/ui/Buttons';
import { ReportDisplay } from '@/components/admin/AssessmentValidator/ReportDisplay';
import useAssessmentValidator from './useAssessmentValidator';

const AssessmentValidator = () => {
  const initialId = new URLSearchParams(window.location.search).get('assessment_id') || '';
  const [assessmentId, setAssessmentId] = useState(initialId);
  const {
    clearReport, error, fetchReport, loading, report, revalidate, validate,
  } = useAssessmentValidator();

  useEffect(() => {
    document.title = 'Assessment Validator - TeachTCI';
    if (initialId) fetchReport(initialId);
  }, [initialId]);

  const handleReset = () => {
    setAssessmentId('');
    clearReport();
    const url = new URL(window.location.href);
    url.searchParams.delete('assessment_id');
    window.history.replaceState(null, '', url.toString());
  };

  const handleValidate = () => {
    validate(assessmentId);
    const url = new URL(window.location.href);
    url.searchParams.set('assessment_id', assessmentId);
    window.history.replaceState(null, '', url.toString());
  };

  return (
    <div>
      <Text className="tw-my-2 tw-pt-3" size="sm">
        Validates multiple choice assessment questions to ensure they can be answered using the section text.
        Provides a report with verdicts (Valid, Invalid, Incorrect, Vague) and rationale for each question.
      </Text>
      <div
        className={`
          tw-flex tw-items-center tw-bg-[#f69c051a] tw-py-1 tw-px-2 tw-border tw-border-solid tw-border-[#f69c05]
          tw-rounded-[4px] tw-text-med tw-gap-2
        `}
      >
        <i aria-hidden="true" className="fa fa-exclamation-triangle tw-text-[#f69c05] tw-m-1 tw-text-lg" />
        <Text size="sm">
          Results are AI-generated and should be verified for accuracy.
        </Text>
      </div>

      {!report && !loading && (
        <>
          <div className="tw-mt-5 tw-flex tw-items-end tw-gap-4">
            <Input
              className="tw-w-96"
              inputMode="numeric"
              label="Assessment ID"
              name="assessmentId"
              placeholder="Enter ID..."
              value={assessmentId}
              onChange={e => setAssessmentId(e.target.value.replace(/\D/g, ''))}
            />
            <SubmitButton
              disabled={!assessmentId.trim() || loading}
              onClick={handleValidate}
            >
              Submit
            </SubmitButton>
          </div>
          {error && (
            <Text className="!tw-text-red tw-mt-2" size="sm">{error}</Text>
          )}
        </>
      )}

      {loading && !report && (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20">
          <i aria-hidden="true" className="fa fa-spinner fa-spin fa-3x tw-text-tci-purple" />
          <Text className="tw-mt-4" size="sm">Validating assessment...</Text>
        </div>
      )}

      {report && (
        <ReportDisplay
          loading={loading}
          report={report}
          onReset={handleReset}
          onRevalidate={revalidate}
        />
      )}
    </div>
  );
};

export default AssessmentValidator;
